module.exports = __webpack_public_path__ + "media/PAG64-10.0edfb330.mp3";